import React, { useState, useEffect, useRef } from "react"
import { useSearchParams, useNavigate } from "react-router-dom"
import { useMutation } from "@tanstack/react-query"
import Cookie from "js-cookie"
import { appStore } from "lib/state"
import { cn, queryTools } from "lib/utils"
import _ from 'lodash';

export default function LoginPage(){

  const [ searchParams, setSearchParams ] = useSearchParams()
  const navigate = useNavigate()
  const { store, AppStore }:any = appStore()
  const { update } = AppStore

  const passwordRef = useRef<any>(null)
  const [ cookieChecked, setCookieChecked ] = useState<boolean>(false)
  const [ cookieUserId, setCookieUserId ] = useState<any>(null)

  const handleLoginSuccess = (data:any) => {
    setFormData((prev:any) => ({ ...prev, password: "" }))
    navigate("/dispute")
  }
  
  const handleLoginError = (err:any) => {
    setFormData((prev:any) => ({ ...prev, password: "" }))
  }

  const loginMutation = useMutation({
    mutationFn: async ({ email, password }:{ email:string; password:string }) => {
      const headers = { headers: { 'Content-Type': 'application/json' } }
      const res = await fetch('/api/user/login', { method: 'POST', body: JSON.stringify({ email, password }), ...headers })
      if (!res.ok) {
        if (res.status === 401) {
          setMessage("Invalid email or password")
          throw new Error('Invalid credentials');
        }
        setMessage("There was an error processing your request")
        throw new Error('Something went wrong');
      }
      return res.json();
    },
    onSuccess: (data) => handleLoginSuccess(data),
    onError: (err) => handleLoginError(err)
  }); 

  const { data:_CookieUser } = queryTools.resource.parseQueryForApi("user.findById", { _id: cookieUserId })

  
  const [ formData, setFormData ] = useState({ email: "", password: "" })
  const [ message, setMessage ] = useState("") 

  const handleInputChange = (e:any) => {
    setMessage("")
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const handleFormSubmit = (e:any) => {
    e.preventDefault()

    if( formData.email.length === 0 || formData.password.length === 0 ){
      return setMessage("Please enter your email and password")
    }

    if( formData.email.length > 0 && formData.password.length > 0 ){
      localStorage.setItem("tb3_login_email", formData.email)
      loginMutation.mutate({ email: formData.email, password: formData.password })
    }
  }

  const cookieCheck = () => {
    const cookie = Cookie.get("tb_app_user")
    if( cookie && cookie.length > 0 ){
      const data = JSON.parse(cookie)
      update("user", data)
      if( data.id && data.id.length > 0 ){
        setCookieUserId(data.id)
      }
    } else {
      setCookieChecked(true)
    }
  }

  useEffect(() => {
    console.log(searchParams.get("logout"))
    if( searchParams.get("logout") !== null ){
      const cookie = Cookie.get("tb_app_user")
      if( cookie && cookie.length > 0 ){
        Cookie.remove("tb_app_user")
      }
      navigate("/")
    }
  },[searchParams])

  useEffect(() => {
    if( searchParams.get("logout") === null && _CookieUser && _CookieUser?.status === "active" ){
      console.log(_CookieUser)
      handleLoginSuccess(_CookieUser)
    }
  },[_CookieUser, searchParams])

  useEffect(() => {
    if( !formData.email ){
      const emailLS = localStorage.getItem("tb3_login_email")
      if( emailLS ){
        setFormData({ ...formData, email: emailLS })
      }
    }
  },[])

  useEffect(() => {
    cookieCheck()
  },[])
  
  if( !cookieChecked ) return <></>
  return (
    <div className="w-screen h-screen flex justify-center items-start pt-[20rem] bg-slate-950">
      <div className="w-5/12 flex flex-col border border-solid border-slate-700 relative p-8">
        <p className="absolute top-[-.7rem] left-3 pl-2 pr-4 bg-slate-950 uppercase text-teal-700">Welcome to Template Builder</p>
        
        <form className="mt-4 flex flex-col gap-6" onSubmit={handleFormSubmit}>

          <div className="w-full flex flex-col gap-1">
            <label className="text-xs uppercase text-white/700 pl-1">Email</label>
            <input 
              type="text" 
              name="email" 
              placeholder="someone@midmetrics.com" 
              value={formData.email}
              onChange={handleInputChange}
              className="w-full h-10 px-2 flex items-center text-base text-white/70 border border-solid border-slate-700 rounded focus:outline-0 focus:border-teal-700 bg-transparent focus:bg-transparent dark:focus:bg-transparent"
            />
          </div>

          <div className="w-full flex flex-col gap-1">
            <label className="text-xs uppercase text-white/700 pl-1">Password</label>
            <input 
              ref={passwordRef}
              type="password" 
              name="password" 
              value={formData.password}
              onChange={handleInputChange}
              autoComplete="off"
              readOnly={true}
              onFocus={() => passwordRef.current.removeAttribute("readonly")}
              className="w-full h-10 px-2 flex items-center text-base text-white/70 border border-solid border-slate-700 rounded focus:outline-0 focus:border-teal-700 bg-transparent focus:bg-transparent"
            />
          </div>

          <div className="w-full flex justify-end items-center pr-1">
            <button 
              className={cn(
                "w-3/12 h-8 px-2 text-base text-white/70 uppercase rounded bg-teal-900",
                (formData.email.length === 0 || formData.password.length === 0) && "opacity-30 bg-teal-950 cursor-not-allowed"
              )}
              type="submit"
            >
              Sign In
            </button>
          </div>

          { message && message.length > 0 && (
            <div className="w-full my-1 flex justify-start items-start text-base pl-1 text-red-500/70">
              { message }
            </div>
          )}

        </form>
      </div>
    </div>
  )

}